import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fly': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M197.8 427.8C210.7 439.5 231.5 461.1 231 478.5 231 479.3 230.9 480.1 230.9 481 229.1 500.8 212.1 512.1 191.8 512 166.8 511.9 151.9 495.2 153.1 476.2 154.1 460 173.6 439.5 185.5 428.6 187.8 426.5 188.2 425.9 191.1 425 194.5 425 195 425.3 197.8 427.8zM331.9 67.3C315.6 41.6 293.3 26.7 268.6 15.2 243.1 4.5 214-0.2 192 0 147.9 0 120.8 13.2 110.9 17.3 57.3 45.2 26.5 87.2 28 158.6 35.1 240.8 125 334.6 183.8 392.4 185.5 394 188.3 396.9 190 397.5L193.3 397.6C195.4 396.9 195.1 397.1 196.8 395.5 249.1 346.3 337.5 249.7 352.7 179.8 359.7 140.6 355.8 107.3 331.9 67.3zM186.8 351.9C158.8 300.8 121.6 221.2 117.5 162.9 114.1 115.4 128.9 31.7 186.8 26.2V351.9zM328.7 180C312.3 236.8 251.4 308 209.8 350.3 237.6 298.4 275 217 277 158.4 278.6 112.5 267.2 52.6 229 27 317.8 45.3 344.5 125.1 328.7 180z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fly.js
// module id = kRFn
// module chunks = 144